import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr;
  gap: 20px;
  align-self: center;
  justify-self: center;
  z-index: 1;
`;

export const ContainerMain = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: 15px;
`;
